import React from 'react'
import {Box} from "grommet";
import {Select} from "antd";
import {BridgeNetworks} from "../../constants";

export interface NetworkSelectProps {
  value?: number[]
  networksIds?: number[]
  onChange?: (value: number) => void
}

export const NetworkSelect = (props: NetworkSelectProps) => {
  const { value, networksIds = [] } = props

  const options = BridgeNetworks.filter((item) => {
    if(networksIds.length > 0) {
      return networksIds.includes(item.id)
    }
    return item
  }).map((network) => {
    return {
      value: network.id,
      label: network.name
    }
  })

  return <Select
    placeholder="Select network"
    size="large"
    value={value as any}
    onChange={props.onChange}
    options={options}
    defaultValue={options.length === 1 ? options[0].value : undefined}
    disabled={networksIds.length === 1}
  />
}
